import React from "react";
import TestimonialsOne from "./testimonialsone";
import TestimonialsTwo from "./testimonialstwo";
import TestimonialsThird from "./testimonialsthird";
const Testimonails = () => {
  return (
    <div>
      <TestimonialsOne />
      <TestimonialsTwo />
      <TestimonialsThird />
    </div>
  );
};

export default Testimonails;
